document.addEventListener('DOMContentLoaded', function () {
  var flipCards = document.querySelectorAll('.alter-flip');

  flipCards.forEach(function (card) {
    card.addEventListener('touchstart', function (e) {
      if (!card.classList.contains('is-flipped')) {
        e.preventDefault();
        document.querySelectorAll('.alter-flip.is-flipped').forEach(function (c) {
          if (c !== card) c.classList.remove('is-flipped');
        });
        card.classList.add('is-flipped');
      }
    }, { passive: false });
  });

  // Product page image gallery — click-through prev/next + dots.
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('.gallery__slide');
    var dots = gallery.querySelectorAll('.gallery__dot');
    var index = 0;

    function show(i) {
      if (slides.length === 0) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () { show(n); });
    });
  });

  // FAQ accordions use native <details>/<summary> — no JS required.
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-variant-picker]').forEach(function (wrapper) {
    var scriptTag = wrapper.querySelector('[data-variant-json]');
    if (!scriptTag) return;
    var variants = JSON.parse(scriptTag.textContent);
    var selects = wrapper.querySelectorAll('select[data-option-position]');
    var productSection = wrapper.closest('.product');
    var hiddenInput = productSection ? productSection.querySelector('input[name="id"]') : null;
    var atcButtons = productSection ? productSection.querySelectorAll('.btn--atc') : [];

    function findMatchingVariant() {
      return variants.filter(function (variant) {
        return Array.prototype.every.call(selects, function (select) {
          return variant['option' + select.dataset.optionPosition] === select.value;
        });
      })[0];
    }

    function updateVariant() {
      var match = findMatchingVariant();
      if (!match || !hiddenInput) return;
      hiddenInput.value = match.id;
      atcButtons.forEach(function (btn) {
        if (match.available) {
          btn.removeAttribute('disabled');
          btn.textContent = 'In den Warenkorb';
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.textContent = 'Ausverkauft';
        }
      });
    }

    selects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });
  });
});
